import React, { useState, useEffect } from 'react';
import CircularProgress from '@material-ui/core/CircularProgress';
import FilledInput from '@material-ui/core/FilledInput';
import CssBaseline from '@material-ui/core/CssBaseline';
import Typography from '@material-ui/core/Typography';
import Container from '@material-ui/core/Container';
import Button from '@material-ui/core/Button';
import Paper from '@material-ui/core/Paper';
import Grid from '@material-ui/core/Grid';
import { NavLink, useHistory } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTimes, faExclamationCircle, faTimesCircle, faCheckCircle } from '@fortawesome/free-solid-svg-icons';
import Checkbox from '@material-ui/core/Checkbox';
import FormControlLabel from '@material-ui/core/FormControlLabel';

import ErrorMessage from '../AppLayouts/ErrorMessage';
import Header from '../Headers/Header';
import '../../scss/components/_sign_in_forms.scss';
import API_PATH from "../../constants/config.json";

const queryString = require('query-string');
const axios = require('axios');
const API_URL = process.env.REACT_APP_BASE_URL;

//Start Signup component code ...
const Welcome = (props) => {
  let history = useHistory();
  const [spacing, setSpacing] = React.useState(2);
  const [errPopUp, setErrPopUp] = React.useState(false);
  const [errMsg, setErrMsg] = React.useState(null);
  const [errPassword, setErrPassword] = React.useState(null);
  const [errFirstName, setErrFirstName] = React.useState(null);
  const [errLasttName, setErrLastName] = React.useState(null);
  const [errConfirmPassword, setErrConfirmPassword] = React.useState(null);
  const [errMsgType, setErrMsgType] = React.useState('error');
  const [values, setValues] = React.useState({
    first_name: "",
    last_name: "",
    email: "",
    pwd: "",
    cnfPwd: "",
    createdby_userid: 0,
    organization: "",
    subdomain: window.location.hostname
  });
  const [firstName, setFirstName] = useState('');
  const [lastName, setLastName] = useState('');
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [disableBtn, setDisableBtn] = useState(true);
  const [agreement, setAgreement] = useState(false);

  const [validFName, setValidFName] = useState(false);
  const [validLName, setValidLName] = useState(false);
  const [validEmail, setValidEmail] = useState(false);
  const [validPwd, setValidPwd] = useState(false);

  const [validLen, setValidLen] = useState(false);
  const [validNum, setValidNum] = useState(false);
  const [validUpper, setValidUpper] = useState(false);
  const [validLower, setValidLower] = useState(false);
  const [validSpecialCh, setValidSpecialCh] = useState(false);

  const [loader, setLoader] = useState(false);

  let vFName = false;
  let vLName = false;
  let vPwd = false;
  let agree = false;

  useEffect(() => {
    if(props.location) {
      const parsed = queryString.parse(props.location.search);
      if (parsed) {
        setEmail(parsed.email);
        setFirstName(parsed.firstname);
        setLastName(parsed.lastname);
        setValidFName(true);
        setValidLName(true);
        setValues({ ...values, email: parsed.email,first_name: parsed.firstname,
        last_name: parsed.lastname, createdby_email:parsed.createdby, organization: parsed.organization, agencyId:parsed.agency_id });        
      }
    } 
  },[])

  const handleChange = name => event => {
    // setErrEmail(false);
    let passwordCheck = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[\^\$\*\.\[\]\{\}\(\)\?\"\!\@\#\%\&\/\\,\>\<\'\:\;\|\_\~\`])[A-Za-z\d\^\$\*\.\[\]\{\}\(\)\?\"\!\@\#\%\&\/\\,\>\<\'\:\;\|\_\~\`]{8,}$/
    let val = event.target.value;
    if (name == 'first_name') {
      setFirstName(val);
      vFName= val !== "" ? val.length <= 250 ? true : false : false;
      setValidFName(vFName);
      if(!vFName)
        setErrFirstName(true);
      else 
        setErrFirstName(false);
    } else if (name == 'last_name') {
      setLastName(val);
      vLName = val !== "" ? val.length <= 250 ? true : false : false;
      setValidLName(vLName);
      if(!vLName)
        setErrLastName(true);
      else 
        setErrLastName(false);
    } else if (name == 'pwd') {
        setPassword(val);
        let tmp = val.length >= 8 ? true : false;
        setValidLen(tmp);
        setValidNum((/\d/).test(val));
        setValidUpper((/[A-Z]/).test(val));
        setValidLower((/[a-z]/).test(val));
        setValidSpecialCh((/[\^\$\*\.\[\]\{\}\(\)\?\"\!\@\#\%\&\/\\,\>\<\'\:\;\|\_\~\`]/).test(val));

        vPwd = passwordCheck.test(val);
        setValidPwd(vPwd);
    } 
    
    setValues({ ...values, [name]: val });   
  }

  const handleAgreement = (e) => {
    setAgreement(e.target.checked);
    agree = e.target.checked;
    if(validFName && validLName && validEmail && validPwd && e.target.checked)
        setDisableBtn(false);
    else 
        setDisableBtn(true);
  }

  const ShowErrPopUP = () => {
    setErrPopUp(false)
  };

  //This method is use for form signup user start ...
  const signUpUser = () => {
    setLoader(true);
    setErrMsg(null);
    setErrPopUp(false);
    try {
      axios({
        method: 'post',
        data: values,
        url: API_URL + API_PATH.signUpInvitedUserAPI,
      })
        .then(function (response) {
          if (response.status && response.status == '200') {
            setFirstName('');
            setLastName('');
            setPassword('');
            setValidLen(false);
            setValidNum(false);
            setValidUpper(false);
            setValidLower(false);
            setValidSpecialCh(false);
            setValidFName(false);
            setValidLName(false);
            setValidEmail(false);
            setValidPwd(false);
            setAgreement(false);
            agree = false;
            history.push({
                pathname: '/sign_in',
                state: { invited: true }
            })
        } else {
            setErrMsgType('error')
            setErrMsg('Something went wrong.');
            setErrPopUp(true)
            setLoader(false);
          }
        }).catch(function (error) {
          if (error.response) {
            setErrMsgType('error');
            setErrMsg('User not found.');
            setErrPopUp(true);
            setLoader(false);               
          } else {
            setErrMsgType('error')
            setErrMsg('Something went wrong.');
            setErrPopUp(true)
            setLoader(false);
          }
        })
    } catch (error) {
      console.error(error);
    }
  }
  //This method is use for form signup user end ...

  return (
    <React.Fragment>
      {/* <Header /> */}
      <CssBaseline />
      <div className="signin-main">
        <Container maxWidth="sm" className="user-form-container" style={{paddingTop: '13px'}}>
          <Typography component="div">
            <div className="form-logo">
              <NavLink to="/" title='Close'><img className="close-icon" src={require('../../assets/icons/close.svg')} /></NavLink>
              <img src={require('../../assets/images/dataPointLogo_xl.svg')} className="form-icon"></img>
            </div>
            <form className="root-form" noValidate autoComplete="off">
              <h3 className="h3-title">Create an account</h3>
              <p className="center-text margin-0"><label className="default-label">Or</label> <NavLink to="/sign_in" className="link-label">I already have an account</NavLink></p>
              <Grid container className="root-box shadow-default">
                <Grid item xs={12}>
                    {errMsg ? <ErrorMessage message={errMsg} visible={ShowErrPopUP} show={errPopUp} msgType={errMsgType} /> : null}
                  <Grid container justify="center" spacing={spacing}>
                    <Grid xs={6} item>
                      <Paper className="paper" >
                      <p className="text-input-label">First Name</p>
                        <FilledInput 
                          id="first_name" 
                          placeholder="" 
                          className={errFirstName ? "form-text-input-error" : "form-text-input"} 
                          type="text" variant="outlined" required 
                          onChange={handleChange('first_name')} 
                          data-testid='first_name' 
                          value={firstName} 
                          endAdornment={ errFirstName && <FontAwesomeIcon icon={faExclamationCircle} className="end-error-icon" /> }
                        />
                      </Paper>
                    </Grid>
                    <Grid xs={6} item>
                      <Paper className="paper" >
                        <p className="text-input-label">Last Name</p>
                        <FilledInput 
                          id="last_name" 
                          placeholder="" 
                          className={errLasttName ? "form-text-input-error" : "form-text-input"} 
                          type="text" variant="outlined" required 
                          onChange={handleChange('last_name')} 
                          data-testid='last_name' 
                          value={lastName} 
                          endAdornment={ errLasttName && <FontAwesomeIcon icon={faExclamationCircle} className="end-error-icon" /> }
                        />
                      </Paper>
                    </Grid>
                    <Grid xs={12} item>
                      <Paper className="paper" >
                        <p className="text-input-label">Password</p>
                        <FilledInput 
                          id="password" 
                          placeholder="" 
                          className={errPassword ? "form-text-input-error" : "form-text-input"} 
                          type="password" variant="outlined" required 
                          onChange={handleChange('pwd')} 
                          data-testid='password' 
                          value={password} 
                          endAdornment={ errPassword && <FontAwesomeIcon icon={faExclamationCircle} className="end-error-icon" /> }
                        />
                      </Paper>
                    </Grid>
                    <Grid xs={12} item className="no-padding-top no-padding-bottom">
                        <label className="gray-light-label">Password must contain the following:</label>
                        <ul className="signup-list">
                          <li className="gray-light-label"><FontAwesomeIcon icon={validLen ? faCheckCircle : faTimesCircle} className={validLen ? "successful-icon" : "error-icon"} /> At least 8 characters</li>
                          <li className="gray-light-label"><FontAwesomeIcon icon={validNum ? faCheckCircle : faTimesCircle} className={validNum ? "successful-icon" : "error-icon"} /> Include a number</li>
                          <li className="gray-light-label"><FontAwesomeIcon icon={validUpper ? faCheckCircle : faTimesCircle} className={validUpper ? "successful-icon" : "error-icon"} /> Include an upper case character</li>
                          <li className="gray-light-label"><FontAwesomeIcon icon={validLower ? faCheckCircle : faTimesCircle} className={validLower ? "successful-icon" : "error-icon"} /> Include a lower case character</li>
                          <li className="gray-light-label"><FontAwesomeIcon icon={validSpecialCh ? faCheckCircle : faTimesCircle} className={validSpecialCh ? "successful-icon" : "error-icon"} /> Include a special character</li>
                        </ul>
                    </Grid>
                    <Grid xs={12} item className="no-padding-top no-padding-bottom">
                        <FormControlLabel
                          value="agreement"
                          control={<Checkbox color="primary" value={agreement} onChange={handleAgreement} />}
                          labelPlacement="end"
                          id="agreement_check_box"
                          className="sign-form-checkbox-lighter"
                        />
                        <label for="agreement_check_box" className="terms-of-service-lbl">I agree to DataPoint <span><a href="https://www.data-point.io/tos-privacy-policy" target="_blank" className="infoText">Terms of Service</a></span> agreement</label>
                    </Grid>
                    <Grid xs={12} item>
                      <Paper className="paper" style={{ textAlign: 'center', display: 'block' }} >
                        <Button type="button" variant="outlined" id="signUp_btn" data-testid="signUp_btn" className="blue-btn" 
                          disabled={ (validFName && validLName && validPwd && agreement) ? false : true}
                          onClick={signUpUser}>
                          {loader == true ?
                            <CircularProgress />
                            :
                            'Create account'
                          }
                        </Button>
                        <div className="signin-divisor"><label>Or</label></div>
                        <p style={{paddingTop: '24px'}} className="margin-0"><NavLink to="/sign_in" data-testid='alreadyAccount' className="link-label font-16">I already have an account</NavLink></p>
                      </Paper>
                    </Grid>
                  </Grid>
                </Grid>
              </Grid>
            </form>
          </Typography>
        </Container>
      </div>
    </React.Fragment>
  );
}

export default Welcome;
//End Signup component code ...